import $ from "jquery";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

const FullScreen = ({ className }) => {
  const handleToggle = useCallback((event) => {
    event.preventDefault();
    const $body = $("body");
    if (!$body.hasClass("full-screen")) {
      $body.addClass("full-screen");
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    } else {
      $body.removeClass("full-screen");
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }, []);

  return (
    <div id="fullscreen" className={className}>
      <span>
        <a href="/" onClick={(event) => handleToggle(event)} title="Full Screen">
          <i className="fa fa-arrows-alt" />
        </a>
      </span>
    </div>
  );
};

FullScreen.propTypes = {
  className: PropTypes.string,
};

export default FullScreen;
